import {
  BLOCKS_MODE,
  BlocksConfigContextType,
  BlocksConfigProvider,
  EditorStateWithSyncer,
  EditorUIProvider,
  GraphQLSyncer,
  ViewerStateWithSyncer,
  useBlocksConfig
} from "@pathwright/blocks-engine"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { Suspense } from "react"
import { ContentEditor } from "../editor/ContentEditor"
import { ContentViewer } from "../viewer/ContentViewer"
import CohortCustomizationAction from "../viewer/CohortCustomizationAction"

const BlocksContent = () => {
  const { mode } = useBlocksConfig()
  return mode === BLOCKS_MODE.EDIT ? (
    <EditorStateWithSyncer>
      <EditorUIProvider>
        <ContentEditor />
      </EditorUIProvider>
    </EditorStateWithSyncer>
  ) : (
    <ViewerStateWithSyncer>
      <ContentViewer>
        <CohortCustomizationAction />
      </ContentViewer>
    </ViewerStateWithSyncer>
  )
}

const BlockContentContainer = ({
  Syncer,
  ...props
}: BlocksConfigContextType & { Syncer?: any }) => {
  const SyncProvider = Syncer || GraphQLSyncer
  const syncKey = [
    props.contextKey,
    props.mode,
    !!props.cohortCustomization
  ].join(":")
  const transport = Syncer
    ? {}
    : {
        graphQLClient: props.graphQLClient,
        graphQLEndpoint: props.graphQLEndpoint,
        authToken: props.authToken
      }

  return (
    <BlocksConfigProvider {...props}>
      <Suspense fallback={<LoadingCircle />}>
        <SyncProvider key={syncKey} {...transport}>
          <BlocksContent />
        </SyncProvider>
      </Suspense>
    </BlocksConfigProvider>
  )
}

export default BlockContentContainer
